module.exports = __webpack_public_path__ + "static/media/smart1.b329aff2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mlekara/smart1.jpg
// module id = 424
// module chunks = 0